import React, { useEffect, useState } from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/HomePage/Banner'
import Footer from '../Component/NavBarFooter/Footer'
import AboutSection from '../Component/HomePage/AboutSection'
import MediaRoom from '../Component/HomePage/MediaRoom'
import WorkProsess from '../Component/HomePage/WorkProsess'
import CVReviewSection from '../Component/HomePage/CVReviewSection'
import RecentNews from '../Component/HomePage/RecentNews'
import { useAuth } from '../Context/ContextProvider'
import Counter from '../Component/HomePage/Counter'
import PopularCategory from '../Component/HomePage/PopularCategory'
import SliderSection from '../Component/HomePage/SliderSection'
function HomePage() {
  const { getHomePage,setWebData } = useAuth()
  const [data, setData] = useState({
    news: [],
    stories: []
  })
  useEffect(() => {
    const fetchHomePage = async () => {
      const result = await getHomePage()
      if (result?.success) {
        setData(result?.data)
        console.log(result?.data);
        setWebData({
          webSettings: result?.data?.webSetting,
          socialMedia: result?.data?.socialLinks

        })
      }
    }
    fetchHomePage()
  }, [])
  return (
    <div>
      <NavBar />
      <Banner />
      <SliderSection />
      <Counter />
      <AboutSection />
      <PopularCategory />
      <WorkProsess />
      <CVReviewSection />
      {data?.stories?.length > 0 ? <MediaRoom latestStory={data?.stories} />:null}
      {data?.news?.length > 0 ? <RecentNews latestNews={data?.news} />:null}
      <Footer />
    </div>
  )
}

export default HomePage